module.exports = __webpack_public_path__ + "3b270d21dfaf13d2fdfdf5e9ebdcf075.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/dollar_tree_2022_chart.png
// module id = 1666
// module chunks = 0